module.exports = __webpack_public_path__ + "img/skypets-3.a25e0361.webp";